/** Global drawer width scale applied by AppDrawer. */
export const DRAWER_SIZE_SCALE = 1.4;

const DRAWER_SIZE_DEFAULT = 378;
const DRAWER_SIZE_LARGE = 736;

export const DRAWER_DEFAULT_WIDTH = Math.round(DRAWER_SIZE_DEFAULT * DRAWER_SIZE_SCALE);
export const DRAWER_LARGE_WIDTH = Math.round(DRAWER_SIZE_LARGE * DRAWER_SIZE_SCALE);

export function scaleDrawerDimension(value: number): number {
  return Math.round(value * DRAWER_SIZE_SCALE);
}
